import { Button } from '@codegouvfr/react-dsfr/Button';
import React from 'react';

export const ResetFiltersButton = ({ onClick }: ResetFiltersButtonProps) => {
  return (
    <Button iconId={'fr-icon-arrow-go-back-line'}
            priority={'tertiary no outline'}
            onClick={() => onClick()}>Effacer les filtres</Button>
  );
};

interface ResetFiltersButtonProps {
  onClick: () => void;
}